import styled from '@mui/styled-engine'
import { Box, Typography } from '@mui/material'

export const CalendarContainer = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
}))

export const GridContainer = styled(Box)(({ theme }) => ({
  display: 'grid',
  gridTemplateColumns: 'repeat(7, 40px)', 
  gridTemplateRows: 'repeat(7, 40px)',
  gap: 0,
  justifyItems: 'center',
  alignItems: 'center',
  marginTop: theme.spacing(1),
}))

export const DayTypography = styled(Typography)(({ theme }) => ({
  fontSize: 12,
  fontWeight: 600,
  lineHeight: 1.714,
  color: theme.palette.primary.main,
}))